/**
 * Route path constants for the redesigned Chat page.
 * These correspond to route entries in `src/appV2/redesign/utils/routes.ts`.
 */
export const CHAT_PAGE_PATH = "/chat" as const;
export const CHAT_PAGE_WITH_CONVERSATION_PATH =
  "/chat/:workplaceId?/:workerId?/:placementId?" as const;
